/*
 * @Description: 全局过滤器
 * @Date: 2019-05-08 09:38:27
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-09-30 18:42:38
 */
import Cookie from './cookies.js'
const user_name = Cookie.getLocalStorage("root_path").user_name;

// 转换时间戳
export function time(dataStr) {
    var time = new Date(dataStr * 1000);

    function timeAdd0(str) { if (str < 10) { str = '0' + str; } return str; }
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + ' ' + timeAdd0(h) + ':' + timeAdd0(mm) + ':' + timeAdd0(s);
}
// 年月日
export function birthday(dataStr) {
    var time = new Date(dataStr * 1000);

    function timeAdd0(str) { if (str < 10) { str = '0' + str; } return str; }
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
}
// 根据时间戳计算年龄
export function age(dataStr) {
    var time = new Date(dataStr * 1000);
    var time_ = new Date();
    var y = time.getFullYear();
    var y_ = time_.getFullYear();
    return y_ - y;
}

// 字符串截取前50位
export function slice(dataStr) {
    let leng = 20;
    if (dataStr == '') { return '' }
    if (dataStr.length < leng) { return dataStr }
    return ` ${dataStr.slice(0,leng)}...`
}

// 掩码手机号
export function cover(dataStr) {
    if (dataStr == '') { return '' }
    if (dataStr == null) { return '' }
    if (user_name == "admin") { return dataStr }
    return ` ${dataStr.slice(0,3)}****${ dataStr.slice(7,11) }`
}

// 字符串截取前10位
export function slice_10(dataStr) {
    let leng = 10;
    if (dataStr == '') { return '' }
    if (dataStr.length < leng) { return dataStr }
    return ` ${dataStr.slice(0,leng)}...`
}